import React from 'react';
import './TechLine.css';

const TechLine = ({ text }) => {
  return (
    <p className="tech-line">{text}</p>
  );
}

export default TechLine;
